<template>
  <div>
    <div v-if="googleMapsLoaded">
      <vue-google-autocomplete
        ref="address"
        :id=addressId
        :classname=classname
        :placeholder=placeholder
        v-on:placechanged="getAddressData"
        v-on:keypress="inputChangeKeyPress"
        :country="['nz']"
      >
      </vue-google-autocomplete>
      <input type="hidden" v-model="streetAddress" name="street_address">
      <input type="hidden" v-model="city" name="city">
      <input type="hidden" v-model="region" name="region">
      <input type="hidden" v-model="suburb" name="suburb">
      <input type="hidden" v-model="postcode" name="postcode">
      <input type="hidden" v-model="country" name="country">
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';

export default {
  components: { VueGoogleAutocomplete },

  data: function () {
    return {
      address: '',
      streetAddress: '',
      city: '',
      region: '',
      suburb: '',
      postcode: '',
      country: '',
      googleMapsLoaded: false,
    };
  },

  props: {
    addressId: {
      default: 'google_address',
      type: String,
    },
    placeholder: {
      default: 'Start typing address *',
      type: String,
    },
    classname: {
      default: 'form-control ph-16',
      type: String,
    }
  },
  watch: {
    address: function (newVal, oldVal) {
      this.$emit('addressvaluechange', newVal, oldVal );
    },
  },
  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData, id) {
      this.address = addressData;
      this.streetAddress = `${addressData.street_number} ${addressData.route}`;
      this.city = addressData.locality;
      this.postcode = addressData.postal_code;
      this.region = addressData.administrative_area_level_1;
      this.country = addressData.country;

      for (let i = 0; i < placeResultData.address_components.length; i++) {
        let addressType = placeResultData.address_components[i].types[0];

        if (addressType === 'sublocality_level_1') {
          this.suburb = placeResultData.address_components[i]['short_name'];
        }
      }
    },

    inputChangeKeyPress () {
      this.address = 'no-address-found';
    },
  },
  mounted() {

    this.$nextTick(() => {
      const vue = this;
      setTimeout(function () {
        vue.googleMapsLoaded = true;
      }, 500)
    });
  },
};
</script>
